import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

const CTASection = () => {
  const { t, tObject, localizePath } = useLanguage();
  const steps = tObject<Array<{ number: string; label: string }>>('cta.steps');

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary via-primary to-primary/95">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-primary-foreground mb-6">
            {t('cta.title')}
          </h2>
          
          <p className="text-lg text-primary-foreground/80 mb-10">
            {t('cta.description')}
          </p>

          {/* Process Steps */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-0 mb-12">
            {steps.map((step, index) => (
              <div key={step.number} className="flex items-center">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 rounded-full bg-chathero-mint/20 border border-chathero-mint/50 text-chathero-mint font-bold text-lg flex items-center justify-center mb-2">
                    {step.number}
                  </div>
                  <span className="text-primary-foreground font-medium text-sm md:text-base whitespace-nowrap">
                    {step.label}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden md:block w-16 lg:w-24 h-0.5 bg-chathero-mint/30 mx-4 mt-[-1.5rem]" />
                )}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="border-2 border-chathero-orange text-white hover:bg-chathero-orange hover:text-primary-foreground font-semibold text-base px-8 bg-transparent animate-pulse" asChild>
              <a href="https://app.chathero.ai/register/essential" target="_blank" rel="noopener noreferrer">
                {t('cta.primary')}
              </a>
            </Button>
            <Button size="lg" className="bg-chathero-mint text-accent-foreground hover:bg-chathero-mint/90 text-base px-8 font-semibold" asChild>
              <a href={localizePath("/kontakt")}>
                {t('cta.secondary')}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
